export const makeMUApiUrl = (path: string): string =>
  `${process.env.REACT_APP_MU_API_URL}${path}`;
